// extracted by mini-css-extract-plugin
module.exports = {"page-header":"header_page-header__jqx_u","page-header-title":"header_page-header-title__pYkWM"};